/*
* 在有些人的返回信息中,有的使用msg有的使用message
* 除此之外在没有这些信息时,我们也想自己添加自定义的信息,此方法用来这种需求
 */
function formatMsg(data, str) {
    let _str;
    try {
        _str = data.msg || data.message || str;
    }
    catch (error) {
        console.error(error);
        _str = str;
    }
    return _str;
}
// 信息方法,修饰
let msg = (function () {
    function msg(data, str, { icon = "none" } = {}) {
        wx.showToast({
            icon,
            title: formatMsg(data, str)
        });
    }
    msg.success = function (data, str) {
        msg(data, str, {
            icon: 'success'
        });
    };
    msg.error = function (data, str) {
        msg(data, str);
    };
    return msg;
})();
export default formatMsg;
export { formatMsg, msg };
